module.exports = __webpack_public_path__ + "static/media/th-blueprint-cy.5fe7ccd4.svg";